module.exports = __webpack_public_path__ + "assets/img/5.2297ed66.webp";